import { render, staticRenderFns } from "./TemplateRuleInput.vue?vue&type=template&id=741cafba&"
import script from "./TemplateRuleInput.vue?vue&type=script&lang=ts&"
export * from "./TemplateRuleInput.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateRuleInput.vue?vue&type=style&index=0&id=741cafba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports